import { Box, Center, Flex, FormLabel, Select, Spinner, TableContainer, Td, Text, Th, Tr, useMediaQuery } from '@chakra-ui/react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useState } from 'react'
import { Table, Tbody, Thead } from '../../components/Table'
import { List } from './List'
import { Columns } from './Columns'
import { Filtro } from './Filtro'
import { user } from '../../helpers/user'
import { useNavigate } from 'react-router-dom'
import { useVendedoresMensal } from '../../hooks/useVendedoresMensal'
import { Pagination } from '../../components/Pagination'
import { permissoesUsuariosPropostas } from '../../utils/permissoesUsuariosProposta'
import { CustomTooltip } from '../../components/CustomTooltip'
import { useQuery, useQueryClient } from 'react-query'
import { format } from 'date-fns'
import { formatPrice } from '../../utils/formatPrice'
import { infoColor } from '../../utils/infoColorFunil'
import { api } from '../../services/api'

async function getPropostasAcompanhamento({ params, userCode }) {
  const response = await api.get(`/chamado/listar-acompanhados`, {
    params: {
      codigo_consultor: userCode,
      pendencia_novo: params.pendencia_novo, // Adicionando novo parâmetro
      ...params,
    },
  })

  let data = response.data?.data?.data
    ?.map((item) => {
      return {
        ...item,
        link_proposta: `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-pdf-sankhya/${item.nunota}`,
        abertura: item.data_abertura ? format(new Date(item.data_abertura), 'dd/MM/yyyy HH:mm') : '',
        lineColor: infoColor[item.funil_vendas],
        valor_total_parceiro: item.valor_total_parceiro ? formatPrice(item.valor_total_parceiro) : '',
        data_funil: item.data_status ? format(new Date(item.data_status), 'dd/MM/yyyy HH:mm') : '',
        abertura_order: item.data_abertura,
        retornar_em_order: item.retorno_cliente,
        proposta: item.codigo_proposta,
        desconto: item.desconto ? item.desconto : '',
        desconto_order: item.desconto === 'S' ? 1 : 0,
        cliente: item.nome_cliente?.toLowerCase() || '',
        verba: item.verba ? item.verba : '',
        propostaEncaminhada: item.data_proposta_encaminhada,
        layoutEnviado: item.data_encaminhamento_layout ? format(new Date(item.data_encaminhamento_layout), 'dd/MM/yyyy HH:mm') : '',
        funilVendas: item.funil_vendas?.toLowerCase() || '',
        ultimoContato: item.data_perda ? format(new Date(item.data_perda), 'dd/MM/yyyy HH:mm') : '',
        valorProposta: item.valor_proposta ? formatPrice(item.valor_proposta) : '',
        retornarEm: item.retorno_cliente ? format(new Date(item.retorno_cliente), 'dd/MM/yyyy HH:mm') : '',
        dataPropostaEncaminhada: item.data_proposta_encaminhada ? format(new Date(item.data_proposta_encaminhada), 'dd/MM/yyyy HH:mm') : '',

        info_proposta:
          item?.info_proposta &&
          item?.info_proposta?.map((item) => {
            return {
              ...item,
              codigo_produto: item.codigo_produto,
              cor: item.cor,
              quantidade_itens: new Intl.NumberFormat('pt-BR').format(item.quantidade_itens),
            }
          }),
        info_layout:
          item.info_layout &&
          item.info_layout.map((item) => {
            return {
              ...item,
              link_layout: item.link_layout,
              codigo_produto: item.codigo_produto,
              cor: item.cor,
              solicitacao: item.solicitacao
                ? //dd/MM/yyyy às HH:mm
                  format(new Date(item.solicitacao), "dd/MM/yyyy '/' HH:mm")
                : '',
              encaminhado: item.encaminhado ? format(new Date(item.encaminhado), "dd/MM/yyyy '/' HH:mm") : '',
              nome_usuario: item.nome_usuario ? item.nome_usuario : '',
            }
          }),
      }
    })
    .sort((a, b) => b.proposta_fixada - a.proposta_fixada)

  // if (params.pendencias_atrasadas) {
  //     data = data.filter((item, index, self) => self.findIndex((t) => t.codigo_proposta === item.codigo_proposta) === index)
  // }

  return {
    data: data,
    meta: {
      total: response.data?.total,
      lastPage: response.data?.last_page,
      to: response.data?.to,
      limit: response.data?.limit,
      totalPages: response.data.total_pages,
      totalItens: response.data.total_itens,
      perPage: response.data?.data?.to,
      totalizador_origem: response.data?.totalizador_origem,
    },
  }
}

export function Propostas() {
  const { idVendedor } = useParams()
  const [parameters, setParameters] = useState({})

  const queryClient = useQueryClient()

  const history = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')

  const [data, setData] = useState([])
  const [page, setPage] = useState(searchParams.get('page') ? parseInt(searchParams.get('page')) : 1)
  const [meta, setMeta] = useState(null)

  const { customers } = useVendedoresMensal()

  const [orderByT, setOrderByT] = useState({ column: null, direction: 'asc' })

  function orderByDate(column, direction) {
    const sortedData = [...data].sort((a, b) => {
      let valueA = new Date(a[column])
      let valueB = new Date(b[column])

      return direction === 'asc' ? valueA - valueB : valueB - valueA
    })

    queryClient.setQueryData(['propostas', { params: parameters, userCode: idVendedor }], {
      data: sortedData,
      meta: meta,
    })
  }

  const {
    data: dataCustomer,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['propostas', { params: parameters, userCode: idVendedor }],
    queryFn: () => getPropostasAcompanhamento({ params: parameters, userCode: idVendedor }),
    onSuccess: (data) => {
      setData(data?.data)
      setMeta(data?.meta)
    },
    staleTime: 30,
    refetchOnWindowFocus: false,
  })

  function orderBy(column, type) {
    const direction = orderByT.column === column && orderByT.direction === 'asc' ? 'desc' : 'asc'
    setOrderByT({ column, direction })

    if (type === 'date') {
      return orderByDate(column, direction)
    }

    const sortedData = [...dataCustomer.data].sort((a, b) => {
      let valueA = a[column]
      let valueB = b[column]

      if (!isNaN(valueA) && !isNaN(valueB)) {
        valueA = parseFloat(valueA)
        valueB = parseFloat(valueB)
      }

      return direction === 'asc' ? valueA - valueB : valueB - valueA
    })

    queryClient.setQueryData(['propostas', { params: parameters, userCode: idVendedor }], {
      data: sortedData,
      meta: meta,
    })
  }

  function handleSearchParams(params) {
    //guarda os parametros que ja estavam na url e adiciona os novos
    const newParams = new URLSearchParams(searchParams)

    setSearchParams({
      ...Object.fromEntries(newParams),
      ...params,
    })
  }

  function handlePage(page) {
    if (isLoading) return
    setPage(page)

    handleSearchParams({ page: page })
  }

  function handleLimit(limit) {
    if (isLoading) return

    handleSearchParams({ limit: limit })
  }

  const startItem = Math.min((page - 1) * meta?.limit + 1, meta?.totalItens) || 0
  const endItem = Math.min(page * meta?.limit, meta?.totalItens) || 0

  console.log('meta', meta)

  return (
    <Box bgColor="white" minH="100vh" w="full">
      <Flex
        w="full"
        alignItems="center"
        gap={2}
        position="relative"
        justifyContent="center"
        maxWidth="1600px"
        mx="auto"
        {...(isLargerThan1366 && { maxWidth: '1309px' })}
      >
        {permissoesUsuariosPropostas[user.codigo_usuario] && (
          <Select
            ml={2}
            onChange={(e) => history(`/propostas/${e.target.value}?${searchParams}`)}
            maxW="347px"
            w="full"
            minH="51px"
            value={idVendedor}
            borderRadius="0"
            m="0"
          >
            <option value="">Selecione um vendedor</option>
            <option value="0">Todos</option>
            {customers?.map((customer) => (
              <option key={customer.codigo_usuario} value={customer.codigo_usuario}>
                {customer.apelido}
              </option>
            ))}
          </Select>
        )}
        <Box paddingBlock="14px" bg={'#378BBF'} textAlign="center" fontSize="16px" color="white" fontWeight="bold" w="full">
          <CustomTooltip
            label={
              <Text
                mr={permissoesUsuariosPropostas[user.codigo_usuario] && '420px'}
                textAlign="center"
                fontSize="16px"
                color="white"
                fontWeight="bold"
              >
                Propostas: {meta?.totalItens}
              </Text>
            }
          >
            <Table>
              <Thead>
                <Tr>
                  <Th>Atendimento</Th>
                  <Th>WhatsApp</Th>
                  <Th>Site</Th>
                  <Th>Vendedor</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>{meta?.totalizador_origem?.quantidade_atendimento}</Td>
                  <Td>{meta?.totalizador_origem?.quantidade_whatsapp}</Td>
                  <Td>{meta?.totalizador_origem?.quantidade_site}</Td>
                  <Td>{meta?.totalizador_origem?.quantidade_vendedor}</Td>
                </Tr>
              </Tbody>
            </Table>
          </CustomTooltip>
        </Box>
      </Flex>

      <Flex mt="10px" flexDirection="column" justifyContent="center" maxWidth="100%" px={2} mx="auto">
        <Filtro setParameters={setParameters} setMeta={setMeta} />
        <TableContainer overflowY="auto" maxH="calc(100vh - 200px)" pb={'5rem'}>
          <Table mt={4} borderCollapse="collapse" variant="outline">
            <Thead>
              <Columns orderBy={orderBy} ordered={orderByT} />
            </Thead>
            <Tbody>{!isLoading && <List params={parameters} data={dataCustomer?.data} />}</Tbody>
          </Table>
        </TableContainer>
        {isLoading && (
          <Center mt={2}>
            <Spinner />
          </Center>
        )}
        {!isLoading && data.length === 0 && (
          <Text textAlign="center" fontSize="sm" mt={4} fontWeight="semibold" color="gray.500">
            Nenhuma proposta encontrada
          </Text>
        )}
        <Box mt={2} mr="auto" display={data?.length !== 0 ? 'flex' : 'none'} justifyContent="center" alignItems="center" gap={2} mb={5}>
          <Text fontSize="xs" color="gray.500" textAlign="center">
            {startItem} - {endItem} de {meta?.totalItens} propostas
          </Text>
          <Pagination page={page} setPage={handlePage} totalPages={meta?.totalPages} isDisabled={isLoading} />

          <Flex alignItems="center" gap={1}>
            <FormLabel htmlFor="limit" fontSize="xs" color="gray.500" m={0}>
              Itens por página:
            </FormLabel>
            <Select id="limit" w="100px" onChange={(e) => handleLimit(e.target.value)} size="sm" disabled={isLoading}>
              <option selected value="">
                Selecione
              </option>
              {Array.from({ length: Math.ceil(meta?.totalItens / 100) }, (_, index) => (
                <option key={index} value={(index + 1) * 30}>
                  {(index + 1) * 30 <= meta?.totalItens ? `${(index + 1) * 30} itens` : `Até ${meta?.totalItens} itens`}
                </option>
              ))}
              <option value={meta?.totalItens}>Mostrar tudo</option>
            </Select>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}
